/**
 * Register project-specific events for webapp
 *
 * @package ARS Webapp
 * @author René Schulze <schulze@thadeus-roth.de>
 */

import { toRaw } from 'vue';
import config from '?/Config';
import constants from '?/Constants';
import store from '?/Stores';
import emitter from '?/Composable/Events/Emitter';
import { hostel as hostelData, station as stationData } from '?/ProjectData';
import { calculateDistance } from '?/Composable/Geolocation';


export default function registerCustomEvents() {
    const hostelStationId = '99';

    /*
     * Handle hostel station
     */
    emitter.on('*', (e, authToken) => {
        if (['sse-playerstatus', 'geolocation-success'].includes(e)) {
            if (config.debug) {
                console.log(
                    'Webapp event: ', e,
                    'Action: ', 'Handle hostel station'
                );
            }

            let stations = store.getters.stations;

            // Check for special station
            if (!stations.hasOwnProperty(hostelStationId)) {
                return;
            }

            const position = store.getters.geolocation;
            let hostelStation = toRaw(stations[hostelStationId]);

            // Hide hostel station if geolocation is unavailable
            if (!position) {
                hostelStation.secret = true;
                store.commit('station', [hostelStationId, hostelStation]);

                return;
            }

            // Add current distance to hostel
            for (const key in hostelData) {
                hostelData[key]['distance'] = calculateDistance(
                    {
                        lat: hostelData[key].latitude,
                        lng: hostelData[key].longitude
                    },
                    {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    }
                );
            }

            // Get nearest hostel
            let nearestHostelData = hostelData
                .sort((itemA, itemB) => {
                    return itemA.distance - itemB.distance;
                })[0];

            // Fill hostel station with hostel data
            hostelStation.latitude = nearestHostelData.latitude;
            hostelStation.longitude = nearestHostelData.longitude;
            hostelStation.secret = false;

            store.commit('station', [hostelStationId, hostelStation]);

            // Fill station data with hostel data
            stationData
                .map(obj => {
                    if (obj.id == hostelStationId) {
                        obj.title = nearestHostelData.title;
                        obj.desc = nearestHostelData.desc;
                        obj.longDesc = nearestHostelData.longDesc;
                        obj.imagePath = '/assets/webapp-data/hostels/hostel-' + nearestHostelData.id + '.jpg';
                    }

                    return obj;
                });

        }
    });
};
